<div class="dialog-viewer">
    <h2 mat-dialog-title>Create Waiver Entry</h2>
    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <!-- Left Column: Booking Selection -->
                    <div class="col-md-6">
                        <div class="booking-section">
                            <mat-form-field class="w-100 mb-3">
                                <mat-label>Search Bookings</mat-label>
                                <input matInput [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" (keyup)="filterBookings()" placeholder="Search by name, email, or confirmation number">
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>

                            <mat-selection-list #bookingList [multiple]="false" (selectionChange)="onBookingSelection($event)">
                                <mat-list-option *ngFor="let booking of filteredBookings" [value]="booking">
                                    <div class="booking-option">
                                        <div class="customer-name">{{booking.customerName}}</div>
                                        <div class="booking-details">
                                            <span class="confirmation">#{{booking.confirmationNumber}}</span>
                                            <span class="email">{{booking.email}}</span>
                                            <span class="date">{{booking.startTime | date:'h:mm a'}} - {{booking.endTime | date:'h:mm a'}}</span>
                                        </div>
                                    </div>
                                </mat-list-option>
                            </mat-selection-list>
                        </div>
                    </div>

                    <!-- Right Column: Customer Details -->
                    <div class="col-md-6">
                        <div class="details-section">
                            <h3 class="mat-h3 mb-3">Customer Details</h3>
                            <mat-form-field class="w-100">
                                <mat-label>First Name</mat-label>
                                <input matInput formControlName="firstName" required>
                                <mat-error *ngIf="form.get('firstName').errors?.required">First Name is required</mat-error>
                            </mat-form-field>

                            <mat-form-field class="w-100">
                                <mat-label>Last Name</mat-label>
                                <input matInput formControlName="lastName" required>
                                <mat-error *ngIf="form.get('lastName').errors?.required">Last Name is required</mat-error>
                            </mat-form-field>

                            <mat-form-field class="w-100">
                                <mat-label>Email Address</mat-label>
                                <input matInput formControlName="emailAddress" required type="email">
                                <mat-error *ngIf="form.get('emailAddress').errors?.required">Email is required</mat-error>
                                <mat-error *ngIf="form.get('emailAddress').errors?.email">Please enter a valid email address</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button type="submit" [disabled]="!form.valid || isLoading">Send</button>
        </mat-dialog-actions>
    </form>
</div> 